import { cx } from "@suse-o11y/class-variance";
import React from "react";

export interface TimeRangeSelectorSectionProps {
	title: string;
	className?: string;
	children?: React.ReactNode;
}

export const TimeRangeSelectorSection: React.FC<TimeRangeSelectorSectionProps> = ({
	className,
	title,
	children,
	...props
}) => (
	<div {...props} className={cx("space-y-3", className)}>
		<div className="font-medium text-grey-800 text-sm">{title}</div>

		{children}
	</div>
);
